"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formQuestionsToDB = void 0;
const FormQuestionControllerRegistry_1 = __importDefault(require("@opsbase/lib-form/FormQuestionController/FormQuestionControllerRegistry"));
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const createEmptyDB_1 = __importDefault(require("./createEmptyDB"));
const moveQuestion_1 = __importDefault(require("./moveQuestion"));
const processDB_1 = require("./processDB");
const removeQuestionFromParent_1 = __importDefault(require("./removeQuestionFromParent"));
function formQuestionsToDB(form, defaultSubQuestionType) {
    const db = (0, createEmptyDB_1.default)(defaultSubQuestionType);
    db.questions = form.reduce((p, c) => (Object.assign(Object.assign({}, p), { [c.qId]: cloneQuestionWithFullConfig(c) })), {});
    (0, processDB_1.processListChildren)(db, {
        lid: 'root',
        idx: 0,
        childQIds: form.map(q => q.qId),
    });
    Object.values(db.questions).forEach(q => {
        if (q.type === FormQuestionType_1.default.QUESTIONSET) {
            const config = q.config[FormQuestionType_1.default.QUESTIONSET];
            const reversedQs = [...config.questions].reverse();
            reversedQs.forEach(qq => {
                qq.parentQSetId = config.questionSetId;
                (0, moveQuestion_1.default)(db, qq.qId, q.parentListId, q.parentListIdx);
            });
            (0, removeQuestionFromParent_1.default)(db, q);
            delete db.questions[q.qId];
        }
    });
    return db;
}
exports.formQuestionsToDB = formQuestionsToDB;
exports.default = formQuestionsToDB;
function cloneQuestionWithFullConfig(q) {
    const fullConfig = Object.values(FormQuestionType_1.default).reduce((p, c) => (Object.assign(Object.assign({}, p), { [c]: FormQuestionControllerRegistry_1.default[c].createConfig(q.config[q.type]) })), {});
    const cloneQ = (0, cloneDeep_1.default)(q);
    cloneQ.config = Object.assign(Object.assign({}, (0, cloneDeep_1.default)(fullConfig)), cloneQ.config);
    return cloneQ;
}
